import { useCallback } from 'react'
import { useFocusEffect } from '@react-navigation/native'
import moment from 'moment'
import { useSelector } from 'react-redux'
import { loadingEffectsSelector } from '@src/selectors/loading'
import { notificationsLastFetchedAtSelector } from '@src/selectors/notifications'
import { useDispatchAsync } from '@src/utils'

const NOTIFICATION_REFRESH_GUARD_SECONDS = 60

const isNotificationRefreshStale = (lastFetchedAt: string | null) => {
  if (!lastFetchedAt) {
    return true
  }

  return moment().diff(moment(lastFetchedAt), 'seconds') >= NOTIFICATION_REFRESH_GUARD_SECONDS
}

export const useRefreshNotificationsOnFocus = () => {
  const dispatchAsync = useDispatchAsync()
  const lastFetchedAt = useSelector(notificationsLastFetchedAtSelector)
  const loadingEffects = useSelector(loadingEffectsSelector)

  const isNotificationRefreshInFlight = Boolean(
    loadingEffects['notifications/fetch'] ||
      loadingEffects['notifications/fetchLive'] ||
      loadingEffects['notifications/fetchInbox'] ||
      loadingEffects['notifications/fetchInboxNextPage'] ||
      loadingEffects['notifications/fetchInboxSummary'],
  )

  useFocusEffect(
    useCallback(() => {
      if (isNotificationRefreshInFlight || !isNotificationRefreshStale(lastFetchedAt)) {
        return
      }

      const refreshNotifications = async () => {
        try {
          await dispatchAsync({ type: 'notifications/refetch' })
        } catch (_error: any) {
          return
        }
      }

      refreshNotifications()
    }, [dispatchAsync, isNotificationRefreshInFlight, lastFetchedAt]),
  )
}
